import {Backdrop, Box, Modal} from '@mui/material';

import useProfile from '../../../../../hooks/providers/useProfile';

const HeaderOnboardingIframe = () => {
  const {onboardingHelpRessourceModalIFrameSrc: iframeSrc, isOnboardingHelpRessourceModalOpen: isOpen, setIsOnboardingHelpRessourceModalOpen, setOnboardingHelpRessourceModalIFrameSrc} = useProfile();

  const onClose = () => {
    setIsOnboardingHelpRessourceModalOpen(false);
    setOnboardingHelpRessourceModalIFrameSrc('');
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      BackdropComponent={Backdrop}
      BackdropProps={{
        onClick: onClose,
        sx: {backgroundColor: 'rgba(0, 0, 0, 0.5)'}
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '70%',
          height: '90vh',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <iframe src={iframeSrc} width="100%" height="100%" title="Prendre rendez-vous" style={{border: 'none'}} />
      </Box>
    </Modal>
  );
};

export default HeaderOnboardingIframe;
